import { Heart } from "lucide-react";

const LoveLetter = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-romantic py-20 px-4">
      <div className="max-w-3xl w-full animate-fade-in">
        <div className="bg-card/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 border-2 border-primary/20">
          
          <h1 className="font-romantic text-4xl md:text-6xl text-center mb-8 text-foreground flex justify-center items-center gap-4">
            Ana 
            <Heart className="w-12 h-12 text-primary animate-float" fill="hsl(var(--primary))"/>
            Gab
          </h1>
          
          <div className="font-serif text-lg md:text-xl leading-relaxed space-y-6 text-foreground">
            <p className="first-letter:text-5xl first-letter:font-romantic first-letter:text-primary first-letter:mr-1">
              Amor, escrevi essa cartinha para nós, para nos lembrarmos de todos os bons momentos que vivemos juntos. 
              Já são seis da manhã, e eu não consigo parar de escrever, porque sei que um dia isso não será apenas um “site”: 
              será algo que vamos mostrar aos nossos filhos. Aqui, eu vou poder dizer que te amei desde o primeiro mês, que desde aquela primeira festa
              (mesmo te conhecendo há apenas uma semana) eu já sabia que era você quem eu queria ao meu lado em todos os outros meses da minha vida. Espero que esse 
              simples presente dure tanto quanto nós.
            </p>
            
            <p>
              Mal vejo a hora de casar com você, Ana Laura!!!
            </p>
            
            <p className="text-center font-romantic text-2xl md:text-3xl !text-primary mt-8">
              Ass: Seu maior admirador.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoveLetter;
